"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/hu-HU.ts
var hu_HU_exports = {};
__export(hu_HU_exports, {
  AG_CHARTS_LOCALE_HU_HU: () => AG_CHARTS_LOCALE_HU_HU
});
module.exports = __toCommonJS(hu_HU_exports);
var AG_CHARTS_LOCALE_HU_HU = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] sorozat",
  ariaAnnounceFlowProportionLink: "hivatkoz\xE1s ${index} a(z) ${count} k\xF6z\xFCl, ${from}-t\xF3l ${to}-ig, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "${count} k\xF6z\xFCl ${index} csom\xF3pont, ${description}",
  ariaAnnounceGaugeChart: "m\xE9r\u0151m\u0171szer diagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchia diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "szint ${level}[number], ${count}[number] gyermek, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Nyomja meg a Sz\xF3k\xF6zt vagy az Entert a l\xE1that\xF3s\xE1g v\xE1lt\xE1s\xE1hoz",
  ariaLabelAddHorizontalLine: "V\xEDzszintes vonal hozz\xE1ad\xE1sa",
  ariaLabelAnnotationOptionsToolbar: "Jel\xF6l\xE9si lehet\u0151s\xE9gek",
  ariaLabelAnnotationSettingsDialog: "Jel\xF6l\xE9s be\xE1ll\xEDt\xE1sai",
  ariaLabelColorPicker: "Sz\xEDnv\xE1laszt\xF3",
  ariaLabelFinancialCharts: "P\xE9nz\xFCgyi diagramok",
  ariaLabelLegend: "Jelmagyar\xE1zat",
  ariaLabelLegendItem: "${label}, Jelmagyar\xE1zat eleme ${index}-b\u0151l [number] ${count}-b\u0151l [number]",
  ariaLabelLegendItemUnknown: "Ismeretlen jelmagyar\xE1zati elem",
  ariaLabelLegendPageNext: "K\xF6vetkez\u0151 jelmagyar\xE1zat oldal",
  ariaLabelLegendPagePrevious: "El\u0151z\u0151 jelmagyar\xE1zat oldal",
  ariaLabelLegendPagination: "Jelmagyar\xE1zat Lapoz\xE1s",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Tartom\xE1ny",
  ariaLabelRangesToolbar: "Tartom\xE1nyok",
  ariaLabelSettingsTabBar: "Be\xE1ll\xEDt\xE1sok",
  ariaLabelZoomToolbar: "Nagy\xEDt\xE1s",
  ariaValuePanRange: "${min}[percent0to2dp] \xE9s ${max}[percent0to2dp] k\xF6z\xF6tt",
  contextMenuDownload: "Let\xF6lt\xE9s",
  contextMenuPanToCursor: "P\xE1szt\xE1z\xE1s ide",
  contextMenuToggleOtherSeries: "Tov\xE1bbi sorozatok megjelen\xEDt\xE9se/elrejt\xE9se",
  contextMenuToggleSeriesVisibility: "L\xE1that\xF3s\xE1g v\xE1lt\xE1sa",
  contextMenuZoomToCursor: "Nagy\xEDt\xE1s ide",
  dialogHeaderChannel: "Csatorna",
  dialogHeaderDatePriceRange: "D\xE1tum \xE9s \xE1r",
  dialogHeaderDateRange: "D\xE1tum tartom\xE1ny",
  dialogHeaderFibonacciRange: "Fibonacci visszah\xFAz\xF3d\xE1s",
  dialogHeaderLine: "Vonal",
  dialogHeaderPriceRange: "\xC1rtartom\xE1ny",
  dialogHeaderText: "Sz\xF6veg",
  dialogInputAlign: "Igaz\xEDt\xE1s",
  dialogInputColorPicker: "Sz\xEDn",
  dialogInputColorPickerAltText: "Sz\xF6vegsz\xEDn",
  dialogInputExtendAbove: "Kiterjeszt\xE9s f\xF6l\xE9",
  dialogInputExtendBelow: "Kiterjeszt\xE9s al\xE1",
  dialogInputExtendChannelEnd: "Csatorna v\xE9g\xE9nek kiterjeszt\xE9se",
  dialogInputExtendChannelStart: "Csatornakezd\xE9s kiterjeszt\xE9se",
  dialogInputExtendLeft: "Balra kiterjeszt\xE9s",
  dialogInputExtendLineEnd: "Vonalv\xE9g meghosszabb\xEDt\xE1sa",
  dialogInputExtendLineStart: "Vonal kezd\xE9s\xE9nek kiterjeszt\xE9se",
  dialogInputExtendRight: "Ny\xFAjt\xE1s jobbra",
  dialogInputFibonacciBands: "S\xE1vok",
  dialogInputFibonacciBandsAltText: "Fibonacci s\xE1vok",
  dialogInputFillColorPicker: "Kit\xF6lt\xE9s",
  dialogInputFillColorPickerAltText: "Kit\xF6lt\xE9si sz\xEDn",
  dialogInputFontSize: "M\xE9ret",
  dialogInputFontSizeAltText: "Bet\u0171m\xE9ret",
  dialogInputLineStyle: "Szaggatott",
  dialogInputPosition: "Poz\xEDci\xF3",
  dialogInputReverse: "Ford\xEDtott",
  dialogInputShowFill: "Kit\xF6lt\xE9s megjelen\xEDt\xE9se",
  dialogInputStrokeWidth: "S\xFAly",
  dialogInputStrokeWidthAltText: "Vonal s\xFAly",
  iconAltTextAlignCenter: "K\xF6z\xE9pre",
  iconAltTextAlignLeft: "Balra",
  iconAltTextAlignRight: "Jobbra",
  iconAltTextClose: "Bez\xE1r\xE1s",
  iconAltTextLineStyleDashed: "Hossz\xFA szaggatott",
  iconAltTextLineStyleDotted: "R\xF6vid szaggatott",
  iconAltTextLineStyleSolid: "Folyamatos",
  iconAltTextPositionBottom: "Als\xF3",
  iconAltTextPositionCenter: "K\xF6z\xE9pre",
  iconAltTextPositionTop: "Fel\xFCl",
  inputTextareaPlaceholder: "Adjon hozz\xE1 sz\xF6veget",
  measurerDateRangeBars: "${value}[number] oszlopok",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "T\xE9rfogat ${value}",
  overlayLoadingData: "Adatok bet\xF6lt\xE9se...",
  overlayNoData: "Nincs megjelen\xEDthet\u0151 adat",
  overlayNoVisibleSeries: "Nincs l\xE1that\xF3 sorozat",
  overlayUnsupportedBrowser: "Nem kompatibilis b\xF6ng\xE9sz\u0151verzi\xF3. K\xE9rj\xFCk, friss\xEDtse b\xF6ng\xE9sz\u0151j\xE9t.",
  seriesHistogramTooltipCount: "${yName} (darab)",
  seriesHistogramTooltipFrequency: "Gyakoris\xE1g",
  seriesHistogramTooltipMean: "${yName} (\xE1tlag)",
  seriesHistogramTooltipSum: "${yName} (\xF6sszeg)",
  toolbarAnnotationsArrow: "Ny\xEDl",
  toolbarAnnotationsArrowDown: "Ny\xEDl lefel\xE9",
  toolbarAnnotationsArrowUp: "Fel ny\xEDl",
  toolbarAnnotationsCallout: "Kih\xEDv\xE1s",
  toolbarAnnotationsClearAll: "\xD6sszes t\xF6rl\xE9se",
  toolbarAnnotationsComment: "Megjegyz\xE9s",
  toolbarAnnotationsDatePriceRange: "D\xE1tum \xE9s \xC1r",
  toolbarAnnotationsDateRange: "D\xE1tumtartom\xE1ny",
  toolbarAnnotationsDelete: "T\xF6rl\xE9s",
  toolbarAnnotationsDisjointChannel: "Sz\xE9ttart\xF3 Csatorna",
  toolbarAnnotationsDragHandle: "Eszk\xF6zt\xE1r h\xFAz\xE1sa",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fibo visszah\xFAz\xF3d\xE1s",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Trend alap\xFA Fibonacci",
  toolbarAnnotationsFillColor: "Kit\xF6lt\xE9si Sz\xEDn",
  toolbarAnnotationsHorizontalLine: "V\xEDzszintes vonal",
  toolbarAnnotationsLineAnnotations: "Trendvonalak",
  toolbarAnnotationsLineColor: "Vonal sz\xEDne",
  toolbarAnnotationsLineStrokeWidth: "Vonal vastags\xE1ga",
  toolbarAnnotationsLineStyle: "Vonalst\xEDlus",
  toolbarAnnotationsLock: "Z\xE1rol\xE1s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE9r\u0151k",
  toolbarAnnotationsNote: "Megjegyz\xE9s",
  toolbarAnnotationsParallelChannel: "P\xE1rhuzamos csatorna",
  toolbarAnnotationsPriceRange: "\xC1rtartom\xE1ny",
  toolbarAnnotationsQuickDatePriceRange: "M\xE9rt\xE9k",
  toolbarAnnotationsSettings: "Be\xE1ll\xEDt\xE1sok",
  toolbarAnnotationsShapeAnnotations: "Nyilak",
  toolbarAnnotationsText: "Sz\xF6veg",
  toolbarAnnotationsTextAnnotations: "Sz\xF6veges annot\xE1ci\xF3k",
  toolbarAnnotationsTextColor: "Sz\xF6veg sz\xEDne",
  toolbarAnnotationsTextSize: "Sz\xF6veg M\xE9ret",
  toolbarAnnotationsTrendLine: "Trendvonal",
  toolbarAnnotationsUnlock: "Felold\xE1s",
  toolbarAnnotationsVerticalLine: "F\xFCgg\u0151leges vonal",
  toolbarRange1Month: "1H",
  toolbarRange1MonthAria: "1 h\xF3nap",
  toolbarRange1Year: "1 \xC9v",
  toolbarRange1YearAria: "1 \xE9v",
  toolbarRange3Months: "3H",
  toolbarRange3MonthsAria: "3 h\xF3nap",
  toolbarRange6Months: "6 h\xF3",
  toolbarRange6MonthsAria: "6 h\xF3nap",
  toolbarRangeAll: "\xD6sszes",
  toolbarRangeAllAria: "\xD6sszes",
  toolbarRangeYearToDate: "\xC9v elej\xE9t\u0151l",
  toolbarRangeYearToDateAria: "\xC9v elej\xE9t\u0151l",
  toolbarSeriesTypeCandles: "Gyerty\xE1k",
  toolbarSeriesTypeDropdown: "Diagramt\xEDpus",
  toolbarSeriesTypeHighLow: "Magas Alacsony",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\xDCreges gyerty\xE1k",
  toolbarSeriesTypeLine: "Vonal",
  toolbarSeriesTypeLineWithMarkers: "Vonal jel\xF6l\u0151kkel",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "L\xE9pcs\u0151s vonal",
  toolbarZoomPanEnd: "G\xF6rget\xE9s a v\xE9g\xE9re",
  toolbarZoomPanLeft: "Balra mozgat\xE1s",
  toolbarZoomPanRight: "Jobbra g\xF6rd\xEDt\xE9s",
  toolbarZoomPanStart: "Lapoz\xE1s az elej\xE9re",
  toolbarZoomReset: "Nagy\xEDt\xE1s vissza\xE1ll\xEDt\xE1sa",
  toolbarZoomZoomIn: "Nagy\xEDt\xE1s",
  toolbarZoomZoomOut: "Kicsiny\xEDt\xE9s",
  tooltipPaginationStatus: "${index}[number] a(z) ${count}[number]"
};
//# sourceMappingURL=hu-HU.cjs.js.map
